import React, { useState, useEffect, useContext } from "react";
import AddMeetings from "../components/Meetings/AddMeeting";
import UpdateProduct from "../components/UpdateProduct";
import AuthContext from "../AuthContext";
import ViewMeetings from '../components/Meetings/ViewMeetings';
import { useTheme } from '../ThemeContext'; // Adjust the path as necessary
function MeetingsPage() {
  const [showProductModal, setShowProductModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateProduct, setUpdateProduct] = useState([]);
  const [products, setAllProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState();
  const [updatePage, setUpdatePage] = useState(true);
  const [stores, setAllStores] = useState([]);
  const { theme } = useTheme(); // Get the theme from context
  const authContext = useContext(AuthContext);


  // Modal for Product ADD
  const addModalSetting= () => {
    setShowProductModal(!showProductModal);
  };

  // Modal for Product UPDATE
  const updateProductModalSetting = (selectedProductData) => {
    console.log("Clicked: edit");
    setUpdateProduct(selectedProductData);
    setShowUpdateModal(!showUpdateModal);
  };


  // Handle Page Update
  const handlePageUpdate = () => {
    setUpdatePage(!updatePage);
  };

  
  return (
    <div className="col-span-12 lg:col-span-10  flex justify-center">
            <div className="flex flex-col gap-5 w-full"> {/* Flex column with full width */}
        {showProductModal && (
          <AddMeetings
          addModalSetting={addModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        )}
        {showUpdateModal && (
          <UpdateProduct
            updateProductData={updateProduct}
            updateModalSetting={updateProductModalSetting}
          />
        )}

        {/* Table  */}
        <div className={`overflow-x-auto rounded-sm border w-full ${theme === 'dark' ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'}`}> {/* Full width table */}
          <div className="flex justify-between pt-5 pb-3 px-3">
            <div className="flex gap-4 justify-center items-center">
              <span className={`font-bold text-lg ${theme === 'dark' ? 'text-white' : 'text-black'}`}>Meetings</span>
            </div>
            <div className="flex gap-4">
              <button
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold p-2 text-xs  rounded"
                onClick={addModalSetting}
              >
                {/* <Link to="/ViewMeetings/add-product">Add Product</Link> */}
                Add Meetings
              </button>
            </div>
          </div>
          <ViewMeetings handlePageUpdate={handlePageUpdate} updatePage={updatePage} />
        </div>
      </div>
    </div>
  );
}

export default MeetingsPage;
